export default __webpack_public_path__ + "static/media/image16.c21c05ae.jpg";